import FileAttachmentTile from './FileAttachmentTile';
import { PureComponent } from 'react';
import styled from 'styled-components';
import ThemeContext from '../../theming/contexts/ThemeContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const AttachmentsFooterWrapper = styled.div.withConfig({
  displayName: "AttachmentsFooter__AttachmentsFooterWrapper"
})(["cursor:pointer;box-sizing:border-box;display:block;background-color:", ";"], ({
  backgroundColor
}) => backgroundColor);
export const StyledFileAttachmentTile = styled(FileAttachmentTile).withConfig({
  displayName: "AttachmentsFooter__StyledFileAttachmentTile"
})(["background-color:", ";"], ({
  backgroundColor
}) => backgroundColor || 'rgba(255, 255, 255, 0.5)');
class AttachmentsFooter extends PureComponent {
  render() {
    const {
      fileAttachments
    } = this.props;
    const {
      fileAttachmentTheme: {
        tileBackgroundColor
      },
      backgroundColor
    } = this.context;
    return /*#__PURE__*/_jsx(AttachmentsFooterWrapper, {
      "data-test-id": "attachments-footer",
      backgroundColor: backgroundColor,
      children: fileAttachments.map((fileAttachment, index) => {
        return /*#__PURE__*/_jsx(StyledFileAttachmentTile, {
          fileMetadata: fileAttachment,
          backgroundColor: tileBackgroundColor
        }, index);
      })
    });
  }
}
AttachmentsFooter.displayName = 'AttachmentsFooter';
AttachmentsFooter.contextType = ThemeContext;
export default AttachmentsFooter;